import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatInputModule, MatCheckboxModule, MatSlideToggleModule, MatTableModule, MatPaginatorModule, MatSelectModule } from '@angular/material';
import { NgModule } from '@angular/core';
import { OfficeRoutingModule, ROUTABLE_COMPONENTS } from './office.routing';
import { OfficeService } from './shared/office.service';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';
import { GridEmptyModule } from '../../../shared/gridempty/gridempty.module';

//component
import { OfficeListComponent } from './list/office-list.component';
import { OfficeViewComponent } from './view/office-view.component';
import { OfficeEditComponent } from './edit/office-edit.component';
import { OfficeNewComponent } from './new/office-new.component';
import { OfficeComponent } from './office.component';
import { AplicacionModule } from '../Aplicaciones/aplicacion.module';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { AplicacionListComponent } from './listAplicacion/aplicacion-list.component';
import { OfficeAplicacionListComponent } from './listAplicacion/office-aplicacion-list.component';


@NgModule({
  imports: [
    BrowserModule,
    MatTableModule,
    OfficeRoutingModule,
    MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
    FormsModule, ReactiveFormsModule,MatSelectModule,
    FabButtonGroupModule, AplicacionModule,
    SectionBarModule, MatSlideToggleModule, GridEmptyModule,
    TitlebarModule, HeaderModule, LoaderModule, SnackbarModule
  ],
  entryComponents: [],
  exports: [],
  declarations: [
    OfficeListComponent,
    OfficeViewComponent,
    OfficeEditComponent,
    OfficeNewComponent,
    OfficeComponent,
    OfficeAplicacionListComponent,
    AplicacionListComponent,
    ROUTABLE_COMPONENTS
  ],
  providers: [OfficeService],
  bootstrap: []
})
export class OfficeModule {
}
